import { createRoute, lazyRouteComponent } from '@tanstack/react-router';

import { identityVerificationValidateSearchSchema } from '../../../common/identityVerification/helpers/identityVerificationValidateSearchSchema';
import { clientApplicationsRoute } from '../route';

export const clientIdentityVerificationRoute = createRoute({
	getParentRoute: () => clientApplicationsRoute,
	path: '/identity-verification',
	component: lazyRouteComponent(
		() => import('./ClientIdentityVerificationPage'),
		'ClientIdentityVerificationPage',
	),
	validateSearch: identityVerificationValidateSearchSchema,
});
